import React from 'react';
import { SvgType } from '../svgType';

export default ({ color, className }: SvgType) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="31.5"
    height="31.5"
    viewBox="0 0 31.5 31.5"
  >
    <g transform="translate(0.75 0.75)">
      <g transform="translate(15 0)">
        <path
          d="M1760.736-357.28h0a14.931,14.931,0,0,0,2.007-7.5,15,15,0,0,0-15-15v15Z"
          transform="translate(-1747.746 379.78)"
          fill={color}
          stroke={color}
          strokeWidth="1.5"
        />
      </g>
      <path
        d="M1610.62-364.78v-15a15,15,0,0,0-15,15,14.929,14.929,0,0,0,2.008,7.5h0Z"
        transform="translate(-1595.619 379.782)"
        fill="#fff"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M1628.977-212.653a14.993,14.993,0,0,0,12.993-7.5h0l-12.99-7.5-12.991,7.5h0A14.994,14.994,0,0,0,1628.977-212.653Z"
        transform="translate(-1613.977 242.653)"
        fill={color}
        stroke={color}
        strokeWidth="1.5"
      />
    </g>
  </svg>
);
